import instance from "../axios";

const getTableTopics = (IdEventTable: number) => {
    return instance.get(`/Admin/Tables/GetTableTopics`, {
        params: {
            IdEventTable: IdEventTable
        }
    });
}

const insertTableTopic = (IdEventTable: number, Topic: string, Description: string, Availabilities: { StartTime: string; EndTime: string }[]) => {
    return instance.post(`/Admin/Tables/InsertTableTopic`, {
        IdEventTable,
        Topic,
        Description,
        Availabilities
    });
}

export const TableTopicService = {
    getTableTopics,
    insertTableTopic
};